import { AuthorizeAction } from 'modules/core/components/AuthorizeExpiredTrial'
import { Subscription } from 'modules/core/hooks/useCurrentSession'

interface Props {
  disableClick?: boolean
  disabled?: boolean
  className?: string
  onClick?: React.MouseEventHandler<HTMLElement>
  onDrop?: React.DragEventHandler<HTMLElement>
  subscription: Subscription
}

export function ExpiredTrialActionChecker(props: React.PropsWithChildren<Props>) {
  const { onClick } = props

  return props.subscription.inExpiredFreeTrial ? (
    AuthorizeAction(props)
  ) : (
    <div className={props.className} onClick={onClick}>
      {props.children}
    </div>
  )
}
